// طول الرقم الوطني الثابت لكل دولة (بدون كود الدولة وبدون الصفر البادئ).
// المصدر: قواعد ITU-T E.164 والاستخدام الشائع لأرقام الجوّال المحلية.
export const PHONE_LEN = {
  // الشرق الأوسط وشمال أفريقيا
  SA: 9, AE: 9, EG: 10, KW: 8, QA: 8, BH: 8, OM: 8, JO: 9, IQ: 10, LB: 8,
  SY: 9, YE: 9, PS: 9, LY: 9, TN: 8, DZ: 9, MA: 9, EH: 9, SD: 9, SS: 9,
  MR: 8, DJ: 8, SO: 8, KM: 7, IR: 10, TR: 10, IL: 9,
  // أوروبا الغربية والجنوبية
  GB: 10, IE: 9, FR: 9, DE: 11, ES: 9, PT: 9, IT: 10, NL: 9, BE: 9, LU: 9,
  CH: 9, AT: 10, DK: 8, SE: 9, NO: 8, FI: 9, IS: 7, MT: 8, CY: 8, GR: 10,
  MC: 8, LI: 7, AD: 6, SM: 10, VA: 10, GI: 8, GG: 10, JE: 10, IM: 10, FO: 6,
  // أوروبا الشرقية والوسطى
  RU: 10, UA: 9, BY: 9, PL: 9, CZ: 9, SK: 9, HU: 9, RO: 9, BG: 9, MD: 8,
  RS: 8, HR: 9, SI: 8, BA: 8, MK: 8, ME: 8, AL: 9, EE: 8, LV: 8, LT: 8,
  // الأمريكتان
  US: 10, CA: 10, MX: 10, BR: 11, AR: 10, CL: 9, CO: 10, PE: 9, VE: 10,
  UY: 8, PY: 9, BO: 8, EC: 9, GT: 8, HN: 8, NI: 8, CR: 8, PA: 8, CU: 8,
  DO: 10, PR: 10, JM: 10, HT: 8, SV: 8, BS: 10, BB: 10, BZ: 7, TT: 10,
  GD: 10, LC: 10, VC: 10, DM: 10, AG: 10, KN: 10, GY: 7, SR: 7, GF: 9,
  GP: 9, MQ: 9, FK: 5, KY: 10, VG: 10, VI: 10, AI: 10, MS: 10, TC: 10,
  BM: 10, GL: 6, AW: 7, CW: 7, SX: 10, PM: 6, BL: 9, MF: 9, AS: 10,
  // آسيا الجنوبية والشرقية وجنوب شرق آسيا
  IN: 10, PK: 10, BD: 10, LK: 9, NP: 10, BT: 8, MV: 7, AF: 9,
  CN: 11, JP: 10, KR: 10, KP: 10, TW: 9, HK: 8, MO: 8, MN: 8, MM: 9,
  TH: 9, VN: 9, LA: 8, KH: 9, SG: 8, MY: 9, ID: 10, PH: 10, BN: 7, TL: 8,
  // آسيا الوسطى والقوقاز
  KZ: 10, UZ: 9, TJ: 9, KG: 9, TM: 8, AZ: 9, AM: 8, GE: 9,
  // أفريقيا جنوب الصحراء
  NG: 10, KE: 9, ET: 9, GH: 9, UG: 9, TZ: 9, RW: 9, BI: 8, ZM: 9, ZW: 9,
  MW: 9, MZ: 9, AO: 9, NA: 9, BW: 8, LS: 8, SZ: 8, ZA: 9, MG: 9, MU: 8,
  SC: 7, CV: 7, ST: 7, GA: 8, CM: 9, CG: 9, CD: 9, CF: 8, TD: 8, GQ: 9,
  ML: 8, BF: 8, NE: 8, BJ: 8, TG: 8, GN: 9, GW: 9, SL: 8, LR: 8, CI: 10,
  SN: 9, GM: 7, ER: 7, SH: 4, IO: 7,
  // أوقيانوسيا
  AU: 9, NZ: 9, FJ: 7, PG: 8, SB: 7, VU: 5, NC: 6, PF: 6, WS: 7, TO: 5,
  KI: 5, TV: 5, NR: 7, PW: 7, MH: 7, FM: 7, GU: 10, MP: 10, CK: 5, NU: 4,
  TK: 4, WF: 6, NF: 6,
  // قارة أنتاركتيكا وأخرى
  AQ: 6, CX: 6, CC: 6,
};
